import React from "react";
import { Card } from "@/components/ui/card";
import PipelineBoard from "../components/PipelineBoard";

export default function PipelinePage() {
  return (
    <div className="space-y-5" data-testid="dashboard-pipeline">
      <div>
        <h1 className="text-2xl font-heading font-bold text-slate-900">Pipeline</h1>
        <p className="text-sm text-slate-500 mt-1">
          Drag cards between columns to update stage. Click the icon to open the submission.
        </p>
      </div>
      <Card className="p-4">
        <PipelineBoard />
      </Card>
    </div>
  );
}
